/**
 * stock.vue 列表显示的字段相关代码，字段生成，字段排序，字段过滤
 */
import i18nKit from "../../plugins/I18N.js"
let i18n = i18nKit.methods;

import kit from "../../plugins/kit.js"
let api = kit.api;

import {dicts} from "../../plugins/dict.js";

// import Vue from 'vue'
// const h = new Vue().$createElement

/**
 * 
 * @param {*} h  vue的$createElement函数，
 * @returns 
 */
const buildColumns = function(h,vue, details){
    var columns =  [
        {type: 'checkbox', minWidth: 50 ,fixed: 'left'},
        {field: "id", title: i18n.msg("ID"), minWidth: 100,sortable: true,
            slots: {
                default: ({ row }) => {
                    return [
                        <span class="id-cell"><i class="view-cell el-icon-edit-outline"></i>{row.id}&nbsp;<i class="remove-cell el-icon-remove-outline"></i></span>,
                    ];
                },
            }
        }
    ];
  
    details.forEach(e => {

        var col = {
            field: e.fieldName, 
            title: e.nlabel ? e.nlabel : e.label,
            minWidth: e.width || 100,
            sortable: e.sortable == 1 ? true : false,
            visible: true,
        };
        if(e.colName == 'exp_page_status'){
            col['slots'] = {
                default: ({ row }) => {
                    let status = dicts.stockExpPageStatus.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={status?status.type:''}>{status?status.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function({ cellValue }){
                var s = dicts.stockExpPageStatus.find(d => d.value === cellValue);
                return  s?s.label : cellValue;
            }
        }else if(e.colName == 'product_title'){
            col['slots'] = {
                default: ({ row }) => {
                    let title =  row[e.fieldName];
                    return [
                        <el-link href={api.shopeeDetail+"?id="+row.id+"&title="+encodeURIComponent(title)} target="_blank">{title}</el-link>
                    ];
                }
            }
        }else if(e.tableName ==  't_stock' &&e.colName == 'code'){
            // col['formatter'] = function( { cellValue } ){
            //     return cellValue?cellValue:"null";
            // }
            col['slots'] = {
                default: ({ row }) => {
                    let title =  row[e.fieldName];
                    return [
                        // <el-tag click={openDetail(id)}>{title}</el-tag>
                        <span class="id-cell"><i class="detail-cell el-icon-view"></i>{title}</span>
                    ];
                }
            }
        }else if(e.colName == 'exp_code'){
            col['formatter'] = function( { cellValue } ){
                return cellValue?" "+cellValue:"null";
            }
        }else if(e.colName == 'exp_page_code'){
            col['formatter'] = function( { cellValue } ){
                return cellValue?cellValue:"null";
            }
        }
        // else if(e.colName == 'receiver_shop_code'){
        //     // col['formatter'] = function( { cellValue } ){
        //     //     return cellValue?" "+cellValue:"null";
        //     // }
        //     col['slots'] = {
        //         default: ({ row }) => {
        //             return '********';
        //         },
        //     }
        // }else if(e.colName == 'receiver_shop_name'){
        //     col['slots'] = {
        //         default: ({ row }) => {
        //             return '********';
        //         },
        //     }
        // }
        else if(e.colName == 'exp_cod'){
            col['slots'] = {
                default: ({ row }) => {
                    let status = dicts.stockExpType.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={status?status.type:''}>{status?status.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockExpType.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.tableName == 't_stock' && e.colName == 'status'){
            col['slots'] = {
                default: ({ row }) => {
                    let status = dicts.stockStatus.find(d => d.value === row[e.fieldName]);
                    return [
                        <span>
                            {/* <el-tag type={status?status.type:''}>{status?status.label:row[e.fieldName]}</el-tag> */}
                            <el-button size="mini" plain style="cursor: pointer;" 
                                onClick={()=> vue.$refs.traceRef.showTracks(row.id, row.queryHistory)}
                                type={status?status.type:''}>
                                {status?status.label:row[e.fieldName]}
                            </el-button>
                        </span>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockStatus.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.tableName == 't_inventory' && e.colName == 'status'){
            col['slots'] = {
                default: ({ row }) => {
                    let status = dicts.inventoryStatuses.find(d => d.value === row[e.fieldName]);
                    return [
                        // <div style="text-align:left;">
                        //     <div> 
                        //         <span>
                        //             <i class="status-cell iconfont icon-trace font11"></i>
                        //             <el-button size="mini" plain style="cursor: pointer;" 
                        //                 onClick={()=> vue.$refs.inventoryTraceRef.showTracks(row.inventoryId, row.inventoryCode)}
                        //                 type={status?status.type:''}>
                        //                 {status?status.label:row[e.fieldName]}
                        //             </el-button>
                        //         </span>
                        //     </div>
                        // </div>
                        <span>
                            {/* <i class="status-cell iconfont icon-trace font11"></i> */}
                            <el-button size="mini" plain style="cursor: pointer;" 
                                type={status?status.type:''}>
                                {status?status.label:row.status}
                            </el-button>
                        </span>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockStatus.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.tableName == 't_inventory' && e.colName == 'store_type'){
            col['slots'] = {
                default: ({ row }) => {
                    let storeType = dicts.inventoryStoreTypes.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={storeType?storeType.type:''}>{storeType?storeType.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockStatus.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'order_origin'){
            col['slots'] = {
                default: ({ row }) => {
                    let status = dicts.orderOrigin.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={status?status.type:''}>{status?status.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.orderOrigin.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'order_platform'){
            col['slots'] = {
                default: ({ row }) => {
                    let status = dicts.shopTypes.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={status?status.type:''}>{status?status.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.shopTypes.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'err_status'){
            col['slots'] = {
                default: ({ row }) => {
                    let status = dicts.stockErrStatus.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={status?status.type:''}>{status?status.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockErrStatus.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'exp_out_type'){
            col['slots'] = {
                default: ({ row }) => {
                    let outType = dicts.expoutType.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={outType?outType.type:''}>{outType?outType.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function({ cellValue }){
                var s = dicts.expoutType.find(d => d.value === cellValue);
                return  s?s.label : cellValue;
            }
        }else if(e.colName == 'exp_good_type'){
            col['slots'] = {
                default: ({ row }) => {
                    let admin = dicts.stockExpGoodType.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={admin?admin.type:''}>{admin?admin.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockExpGoodType.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'exp_pkg_type'){
            col['slots'] = {
                default: ({ row }) => {
                    let vip = dicts.stockExpPkgType.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={vip?vip.type:''}>{vip?vip.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockExpPkgType.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'store_type'){
            col['slots'] = {
                default: ({ row }) => {
                    let storeType = dicts.stockStoreType.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={storeType?storeType.type:''}>{storeType?storeType.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockStoreType.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'in_store_status'){
            col['slots'] = {
                default: ({ row }) => {
                    let inStoreStatus = dicts.stockInStoreStatus.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={inStoreStatus?inStoreStatus.type:''}>{inStoreStatus?inStoreStatus.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockInStoreStatus.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'exp_allow_print'){
            col['slots'] = {
                default: ({ row }) => {
                    let inStoreStatus = dicts.stockExpAllowPrint.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={inStoreStatus?inStoreStatus.type:''}>{inStoreStatus?inStoreStatus.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockExpAllowPrint.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'is_cancel'){
            col['slots'] = {
                default: ({ row }) => {
                    let inStoreStatus = dicts.cances.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={inStoreStatus?inStoreStatus.type:''}>{inStoreStatus?inStoreStatus.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.cances.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'has_tax'){
            col['slots'] = {
                default: ({ row }) => {
                    let inStoreStatus = dicts.stockHasTax.find(d => d.value === row[e.fieldName]);
                    return [
                        <el-tag type={inStoreStatus?inStoreStatus.type:''}>{inStoreStatus?inStoreStatus.label:row[e.fieldName]}</el-tag>
                    ];
                },
            },
            col['formatter'] = function( { cellValue } ){
                var s = dicts.stockHasTax.find(d => d.value === cellValue);
                return s?s.label : cellValue;
            }
        }else if(e.colName == 'product_thumb'){
            col['slots'] = {
                default: ({ row }) => {
                    let id = row[e.fieldName]
                    return id?[
                        <el-image  style="width: 60px; height: 60px" 
                            src={api.imgView+id} 
                            preview-src-list={[api.imgView+id]}
                            ></el-image>
                    ]: [id];
                },
            }
        }
        else if(e.colName == 'page_id'){
            col['slots'] = {
                default: ({ row }) => {
                    let id = row[e.fieldName]
                    return id?[
                        // <el-image  style="width: 60px; height: 60px" 
                        //     src={api.imgView+id} 
                        // ></el-image>
                        <el-tag type='primary' style="cursor:pointer;">{id}</el-tag>
                    ]: [id];
                },
            }
        }
        else if(e.colName == 'video_img'){
            col['slots'] = {
                default: ({ row }) => {
                    let id = row[e.fieldName]
                    return id?[
                        <el-image  style="width: 60px; height: 60px" 
                            src={api.imgView+id} 
                            preview-src-list={[api.imgView+id]} 
                        ></el-image>
                    ]: [id];
                },
            }
        }
        else if(['transit_status', 'pay_in_status'].indexOf(e.colName)>-1){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    if(!val){
                        return '未计算';
                    }
                    return val == 1 ? i18n.msg('待付'): val==2?i18n.msg('已扣款'): val==3?i18n.msg('已出账单'):'';
                },
            },
            col['formatter'] = function( { cellValue } ){
                if(!cellValue){
                    return '';
                }
                return cellValue == 1 ? i18n.msg('待付'): cellValue==2?i18n.msg('已扣款'): cellValue==3?i18n.msg('已出账单') :cellValue;
                
            }
        }else if('lipei_status' == e.colName){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    if(val === null){
                        return '无';
                    }
                    return val === 0 ? '无' : val === 1 ? i18n.msg('未理赔') : val === 2 ? i18n.msg('已理赔') : val === 3 ? i18n.msg('待付') : val;
                },
            },
            col['formatter'] = function( { cellValue } ){
                if(cellValue === null){
                    return '无';
                }
                return cellValue === 0 ? '无' : cellValue === 1 ? i18n.msg('未理赔') : cellValue === 2 ? i18n.msg('已理赔') : cellValue === 3 ? i18n.msg('待付') : cellValue;
            }
        }else if('kesu_status' == e.colName){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    if(val === null){
                        return '无';
                    }
                    return val === 0 ? '无' : val === 1 ? i18n.msg('待结算') : val === 2 ? i18n.msg('已结算') : val;
                },
            },
            col['formatter'] = function( { cellValue } ){
                if(cellValue === null){
                    return '无';
                }
                return cellValue === 0 ? '无' : cellValue === 1 ? i18n.msg('待结算') : cellValue === 2 ? i18n.msg('已结算') : cellValue;
            }
        }else if('level' == e.colName){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    if(val === null){
                        return '无';
                    }
                    return val === 0 ? '无' : val === 1 ? i18n.msg('一级') : val === 2 ? i18n.msg('二级') : val === 2 ? i18n.msg('三级') : val;
                },
            },
            col['formatter'] = function( { cellValue } ){
                if(cellValue === null){
                    return '无';
                }
                return cellValue === 0 ? '无' : cellValue === 1 ? i18n.msg('一级') : cellValue === 2 ? i18n.msg('二级') : cellValue === 2 ? i18n.msg('三级') : cellValue;
            }
        }else if('pack_type' == e.colName){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    if(val === null){
                        return '无';
                    }
                    return val === 0 ? '普通' : val === 1 ? '精细' : val;
                },
            },
            col['formatter'] = function( { cellValue } ){
                if(cellValue === null){
                    return '无';
                }
                return cellValue === 0 ? '普通' : cellValue === 1 ? '精细' : cellValue;
            }
        }else if('purchase_status' == e.colName){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    if(val === null){
                        return '无';
                    }
                    return val === 0 ? '待采购' : val === 1 ? '已采购' : val;
                },
            },
            col['formatter'] = function( { cellValue } ){
                if(cellValue === null){
                    return '无';
                }
                return cellValue === 0 ? '待采购' : cellValue === 1 ? '已采购' : cellValue;
            }
        }else if('transit_type' == e.colName){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    if(val === null){
                        return '';
                    }
                    let types =  [i18n.msg("空运"), i18n.msg("海运"), i18n.msg("按票"), i18n.msg("特殊1"), i18n.msg("特殊2"),  i18n.msg("特殊3")];
                    let label = types[val];
                    return label || val;
                },
            },
            col['formatter'] = function( { cellValue } ){
                if(cellValue === null){
                    return '';
                }
                let types =  [i18n.msg("空运"), i18n.msg("海运"), i18n.msg("按票"), i18n.msg("特殊1"), i18n.msg("特殊2"),  i18n.msg("特殊3")];
                let label = types[cellValue];
                return label || cellValue;
            }
        }else if('is_after_tax' == e.colName){
            col['slots'] = {
                default: ({ row }) => {
                    let val = row[e.fieldName];
                    return val == 1 ? i18n.msg("包税") : i18n.msg("不包税")
                },
            },
            col['formatter'] = function( { cellValue } ){
                return cellValue == 1 ? i18n.msg("包税") : i18n.msg("不包税")
            }
        }
        // else if('receiver' == e.colName){
        //     col['slots'] = {
        //         default: ({ row }) => {
        //             // let val = row[e.fieldName];
        //             // return this.replaceStr(val,1,'*');
        //             return '***';
        //         },
        //     }
        // }
        // else if(e.colName == 'receiver_tel'){
        //     col['formatter'] = function( { cellValue } ){
        //         return cellValue?" "+cellValue+" ":"null";
        //     }
        // }
        // else if('receiver_tel' == e.colName){
        //     col['slots'] = {
        //         default: ({ row }) => {
        //             return '********';
        //         },
        //     }
        // }else if('receiver_addr' == e.colName){
        //     col['slots'] = {
        //         default: ({ row }) => {
        //             return '****************';
        //         },
        //     }
        // }

        if(e.filterType == 'search'){
            col['filters'] = [{data:''}];
            col['filterRender'] = {name: 'FilterInput'};
        }else if(e.filterType == 'content'){
            col['filters'] = [{data: {vals: [], sVal: '', my: "t_stock"}}];
            col['filterRender'] = {name: 'StockFilterContent'};
        }else if(e.filterType == 'type'){
            col['filters'] = dicts[e.filterOptionKey];
        }else if(e.filterType == 'complex'){
            col['filters'] = [{data: {type: 'has', isCase: false, name: ''}}];
            col['filterRender'] = {name: 'FilterComplex'};
        }else if(e.filterType == 'date'){
            col['filters'] = [{data: []}];
            col['filterRender'] = {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            };
        }

        columns.push(col);
    });

    return columns;
}


export default {
    buildColumns: buildColumns
}
